import React from "react";
import { Button, Descriptions, Modal, Typography } from "antd";
import HomeworkImpactDescriptions from "../../ResourceHomeworkImpactModal/HomeworkImpactDescriptions";
import type { GameQuizReuploadImpact } from "../../../services/gameQuiz/gameQuiz.types";

const { Paragraph } = Typography;

interface QuizReuploadImpactModalProps {
  // Open while there is one to confirm.
  impact: GameQuizReuploadImpact | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * SCRUM-1581: shown before a YAML re-upload over a quiz that homework or
 * student attempts outside Emmi's own schools already reach. It only informs:
 * Confirmar saves on the same quiz and resource, Cancelar saves nothing.
 */
const QuizReuploadImpactModal: React.FC<QuizReuploadImpactModalProps> = ({
  impact,
  onConfirm,
  onCancel,
}) => (
  <Modal
    open={impact !== null}
    title="Este quiz tiene tareas asignadas o intentos registrados"
    onCancel={onCancel}
    width={720}
    destroyOnClose
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Cancelar
      </Button>,
      <Button key="confirm" type="primary" onClick={onConfirm}>
        Confirmar
      </Button>,
    ]}
  >
    <Paragraph type="secondary">
      Si confirmas, el quiz se actualiza con el YAML y conserva su ID. Las
      calificaciones ya registradas se conservan, pero las respuestas guardadas
      no se corresponderán con las preguntas nuevas y los intentos en curso se
      calificarán con la versión nueva.
    </Paragraph>
    {impact && (
      <HomeworkImpactDescriptions counts={impact}>
        <Descriptions.Item label="Resultados registrados">
          {impact.completed_attempt_count}
        </Descriptions.Item>
      </HomeworkImpactDescriptions>
    )}
    <Paragraph type="secondary" style={{ marginTop: 12, marginBottom: 0 }}>
      No se cuentan los registros de Colegio Rincón de Luz, Academia Emmi y Mac
      Test.
    </Paragraph>
  </Modal>
);

export default QuizReuploadImpactModal;
